(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgx-home-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-rgx-hh-cta]')) window.dispatchEvent(new CustomEvent('rgx:open-selector'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgx-vehicle-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('rgx-vehicle-bar')) return;
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
    function readVehicle() { try { return JSON.parse(localStorage.getItem('rgx.vehicle') || 'null'); } catch (e) { return null; } }
    function fmtPrice(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return String(v);
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      var lang = document.documentElement.lang || 'de';
      try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur }).format(n); }
      catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
    }
    /* v2.2: keep products whose title contains every query word (see header) */
    function words(t) { return String(t).toLowerCase().split(/[^0-9a-zäöüß.]+/).filter(Boolean); }
    function refine(q, prods) {
      var toks = words(q);
      if (!toks.length) return prods;
      var keep = prods.filter(function (p) {
        var title = String(p.title || ''), ws = words(title), flat = ws.join('');
        var spans = [], m, re = /((?:19|20)\d\d)\s*[-–—]\s*((?:19|20)\d\d)/g;
        while ((m = re.exec(title))) spans.push([+m[1], +m[2]]);
        return toks.every(function (t) {
          if (/^(19|20)\d\d$/.test(t) && spans.length) {
            return spans.some(function (r) { return +t >= r[0] && +t <= r[1]; });
          }
          return ws.some(function (w) { return w.indexOf(t) === 0; }) || (t.length > 2 && flat.indexOf(t) > -1);
        });
      });
      return keep.length ? keep : prods;
    }

    class RgxVehicleBar extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.dlg = this.querySelector('[data-vb-dialog]');
        this.sdlg = this.querySelector('[data-vb-sdialog]');
        this.label = this.querySelector('[data-vb-label]');
        this.titleEl = this.querySelector('[data-vb-title]');
        this.current = this.querySelector('[data-vb-current]');
        this.currentLabel = this.querySelector('[data-vb-current-label]');
        this.querySelector('[data-vb-toggle]').addEventListener('click', function () { self.openDrawer(); });
        this.querySelector('[data-vb-close]').addEventListener('click', function () { self.dlg.close(); });
        this.querySelector('[data-vb-clear]').addEventListener('click', function () { self.clearVehicle(); });
        this.querySelector('[data-vb-sopen]').addEventListener('click', function () { self.openSearch(); });
        this.querySelector('[data-vb-sclose]').addEventListener('click', function () { self.sdlg.close(); });
        [this.dlg, this.sdlg].forEach(function (d) {
          d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
        });
        window.addEventListener('rgx:vehicle', function (e) { self.render(e.detail); });
        window.addEventListener('rgx:open-selector', function () { self.openDrawer(); });
        this.wireSearch(this.querySelector('[data-vb-q]'), this.querySelector('[data-vb-res]'), null);
        this.wireSearch(this.querySelector('[data-vb-sq]'), this.querySelector('[data-vb-sres]'), this.querySelector('[data-vb-sempty]'));
        document.addEventListener('click', function (e) {
          var box = self.querySelector('[data-vb-search]');
          if (box && !box.contains(e.target)) self.hide(self.querySelector('[data-vb-res]'), self.querySelector('[data-vb-q]'));
        });
        this.render(readVehicle());
      }
      render(v) {
        var has = !!(v && v.label);
        this.label.textContent = has ? v.label : this.dataset.empty;
        this.classList.toggle('rgx-vb--set', has);
        this.titleEl.textContent = has ? this.titleEl.dataset.change : this.titleEl.dataset.add;
        this.current.hidden = !has;
        this.currentLabel.textContent = has ? v.label : '';
      }
      openDrawer() {
        this.render(readVehicle());
        if (!this.dlg.open) this.dlg.showModal();
        var sel = this.dlg.querySelector('select');
        if (sel) setTimeout(function () { try { sel.focus(); } catch (e) {} }, 60);
      }
      openSearch() {
        if (!this.sdlg.open) this.sdlg.showModal();
        var q = this.querySelector('[data-vb-sq]');
        setTimeout(function () { try { q.focus(); } catch (e) {} }, 60);
      }
      clearVehicle() {
        try { localStorage.removeItem('rgx.vehicle'); } catch (e) {}
        window.dispatchEvent(new CustomEvent('rgx:vehicle', { detail: null }));
        this.render(null);
      }
      hide(res, input) { if (!res) return; res.hidden = true; if (input) input.setAttribute('aria-expanded', 'false'); }
      wireSearch(input, res, empty) {
        if (!input || !res) return;
        var self = this, timer = null;
        input.addEventListener('input', function () {
          clearTimeout(timer);
          timer = setTimeout(function () { self.suggest(input, res, empty); }, 180);
        });
        input.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.hide(res, input); });
      }
      suggest(input, res, empty) {
        var q = input.value.trim(), self = this;
        if (q.length < 2) { this.hide(res, input); if (empty) empty.hidden = false; return; }
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (d) {
          if (input.value.trim() !== q) return;
          var r = (d && d.resources && d.resources.results) || {};
          var cols = r.collections || [], prods = refine(q, r.products || []).slice(0, 6), html = '';
          cols.slice(0, 3).forEach(function (c) {
            html += '<a class="rgx-vb__opt rgx-vb__opt--col" role="option" href="' + esc(c.url) + '"><span class="rgx-vb__tag">▸</span>' + esc(c.title) + '</a>';
          });
          prods.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + '&width=96" alt="" width="48" height="48" loading="lazy">' : '<span class="rgx-vb__ph"></span>';
            html += '<a class="rgx-vb__opt" role="option" href="' + esc(p.url) + '">' + img +
              '<span class="rgx-vb__opt-body"><span class="rgx-vb__opt-title">' + esc(p.title) + '</span>' +
              (p.price ? '<span class="rgx-vb__opt-price">' + esc(fmtPrice(p.price)) + '</span>' : '') + '</span></a>';
          });
          if (!html) {
            var link = self.dataset.request + (self.dataset.request.indexOf('?') > -1 ? '&' : '?') + 'build=' + encodeURIComponent(q);
            html = '<p class="rgx-vb__none">' + esc(self.dataset.msgNone) + ' „' + esc(q) + '“ — <a href="' + esc(link) + '">' + esc(self.dataset.msgCta) + ' →</a></p>';
          } else {
            html += '<a class="rgx-vb__all" href="' + esc(root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last') + '">' + esc(self.dataset.viewAll) + ' „' + esc(q) + '“ →</a>';
          }
          res.innerHTML = html;
          res.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          if (empty) empty.hidden = true;
        }).catch(function () { self.hide(res, input); });
      }
    }
    customElements.define('rgx-vehicle-bar', RgxVehicleBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgx-vehicle-request"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-rgx-vr]');
    if (!root) return;
    var KEY = 'rgxVehicleRequest';
    var params = new URLSearchParams(window.location.search);
    var clean = function (s, n) { return (s || '').replace(/\s+/g, ' ').trim().slice(0, n); };
    var build = clean(params.get('build'), 80);
    var make = clean(params.get('make'), 40);
    var lights = clean(params.get('lights'), 30);

    // thank-you: Shopify reloads without the query string after a successful post
    var done = root.querySelector('[data-vr-done]');
    if (done) {
      var stored = null;
      try { stored = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (e) {}
      if (stored) {
        var t = root.querySelector('[data-vr-done-text]');
        if (t) t.textContent = done.dataset.template.replace('{vehicle}', stored);
      }
      return;
    }

    var vehicle = root.querySelector('[data-vr-vehicle]');
    var body = root.querySelector('[data-vr-body]');
    var lead = root.querySelector('[data-vr-lead]');
    if (build && vehicle && !vehicle.value) {
      vehicle.value = build;
      if (lead) lead.textContent = lead.dataset.vehicle.replace('{vehicle}', build);
    }
    if (lights) {
      var radios = root.querySelectorAll('input[name="contact[Gesucht]"]');
      radios.forEach(function (r) { if (r.value.toLowerCase() === lights.toLowerCase()) r.checked = true; });
    }
    if (make) {
      var p = root.querySelector('[data-vr-browse]');
      var a = root.querySelector('[data-vr-browse-link]');
      var handle = make.toLowerCase().replace(/š/g, 's').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (p && a) {
        a.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'collections/' + handle;
        a.textContent = a.dataset.template.replace('{make}', make) + ' →';
        p.hidden = false;
      }
    }
    if (window.innerWidth < 750 && build) {
      var email = root.querySelector('#RgxVr-email');
      if (email) setTimeout(function () { email.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
    }

    var form = root.querySelector('form');
    if (form) form.addEventListener('submit', function () {
      var v = clean(vehicle && vehicle.value, 80);
      var g = root.querySelector('input[name="contact[Gesucht]"]:checked');
      if (body) body.value = 'Fahrzeuganfrage: ' + v + (g ? '\nGesucht: ' + g.value : '');
      try { sessionStorage.setItem(KEY, v); } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgx-vehicle-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('rgx-vehicle-search')) return;
    function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
    class RgxVehicleSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.rgx-vsr__input');
        this.drop = this.querySelector('.rgx-vsr__drop');
        this.timer = null;
        this.input.addEventListener('input', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.suggest(), 180); });
        this.input.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
        document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.close(); });
      }
      close() { this.drop.hidden = true; this.input.setAttribute('aria-expanded', 'false'); }
      suggest() {
        var q = this.input.value.trim();
        if (q.length < 2) { this.close(); return; }
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        var self = this;
        fetch(url).then(function (r) { return r.json(); }).then(function (d) {
          if (self.input.value.trim() !== q) return;
          var res = (d && d.resources && d.resources.results) || {};
          var cols = res.collections || [], prods = res.products || [];
          var html = '';
          cols.slice(0, 3).forEach(function (c) {
            html += '<a class="rgx-vsr__opt rgx-vsr__opt--col" role="option" href="' + esc(c.url) + '"><span class="rgx-vsr__tag">▸</span>' + esc(c.title) + '</a>';
          });
          prods.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + '&width=96" alt="" width="48" height="48" loading="lazy">' : '<span class="rgx-vsr__ph"></span>';
            html += '<a class="rgx-vsr__opt" role="option" href="' + esc(p.url) + '">' + img +
              '<span class="rgx-vsr__opt-body"><span class="rgx-vsr__opt-title">' + esc(p.title) + '</span>' +
              (p.price ? '<span class="rgx-vsr__opt-price">' + esc(p.price) + ' €</span>' : '') + '</span></a>';
          });
          if (!html) html = '<p class="rgx-vsr__none">' + esc(self.dataset.empty) + '</p>';
          html += '<button type="submit" class="rgx-vsr__all">' + esc(self.dataset.all) + ' „' + esc(q) + '“ →</button>';
          self.drop.innerHTML = html;
          self.drop.hidden = false;
          self.input.setAttribute('aria-expanded', 'true');
        }).catch(function () { self.close(); });
      }
    }
    customElements.define('rgx-vehicle-search', RgxVehicleSearch);
  })();

  } catch(e) { console.error(e); }
})();
})();
